/* eslint-disable react-hooks/exhaustive-deps */
import { Box } from "@chakra-ui/react";
import CustomerSidebar from "components/sidebar/CustomerSidebar";
import CustomerMobileMenu from "components/sidebar/CustomerMobileMenu";
import { SidebarContext } from "contexts/SidebarContext";
import { SupportUnreadProvider } from "contexts/SupportUnreadContext";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import routes from "routes";
import { userSelector } from "store/user/selector";
import { logoutRequest } from "store/user/reducer";
import { setAlertMessageRequest } from "store/ui/reducer";
import { USER_ROLE_TYPE } from "constants/statuses";
import { IntercomProvider } from "react-use-intercom";

export default function CustomerLayout(props: { [x: string]: any }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(userSelector);
  const INTERCOM_APP_ID = process.env.INTERCOM_APP_ID ?? "c596pjrx";
  const location = useLocation();

  useEffect(() => {
    if (
      !location?.pathname?.includes("/customer/main") &&
      !location?.pathname?.includes("/customer/order")
    ) {
      localStorage.removeItem("redeem");
    }
  }, [location]);

  useEffect(() => {
    document.body.classList.add("customer-font");
    return () => {
      document.body.classList.remove("customer-font");
    };
  }, []);

  useEffect(() => {
    if (user && user.user_role_type_id !== String(USER_ROLE_TYPE.CUSTOMER)) {
      dispatch(
        setAlertMessageRequest({
          type: "error",
          message: "You don't have access this page",
        })
      );

      localStorage.removeItem("access_token");
      localStorage.removeItem("user_details");
      dispatch(logoutRequest());
      navigate("/auth/sign-in/");
    }
  }, [user]);

  const { ...rest } = props;
  const [toggleSidebar, setToggleSidebar] = useState(false);
  // functions for changing the states from components
  const getRoute = () => {
    return window.location.pathname !== "/admin/full-screen-maps";
  };

  const getRoutes = (routes: RoutesType[]): any => {
    return routes.map((route: RoutesType, key: any) => {
      if (route.layout === "/customer") {
        return (
          <Route key={key} path={route.path} Component={route.component} />
        );
      } else {
        return null;
      }
    });
  };

  document.documentElement.dir = "ltr";

  return (
    <Box fontFamily="General Sans, Inter, sans-serif">
      <IntercomProvider appId={INTERCOM_APP_ID} autoBoot={false}>
        <SupportUnreadProvider>
          <SidebarContext.Provider
            value={{
              toggleSidebar,
              setToggleSidebar,
            }}
          >
            <CustomerSidebar
              routes={routes.filter((it) => it.layout === "/customer")}
              display="none"
              {...rest}
            />
            <CustomerMobileMenu routes={routes.filter((it) => it.layout === "/customer")} />
            <Box
              ml={{ base: 0, xl: "296px" }}
              pt={{ base: "72px", xl: 0 }}
              minH="100vh"
              transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
              transitionDuration=".2s, .2s, .35s"
              transitionProperty="top, bottom, width"
              transitionTimingFunction="linear, linear, ease"
              position="relative"
              zIndex="1"
            >
              {getRoute() ? (
                <>
                  <Box
                    minH="100vh"
                    pb="40px"
                    mx="auto"
                    w="100%"
                    display="flex"
                    flexDirection="column"
                    position="relative"
                    zIndex="1"
                  >
                    <Routes>
                      {getRoutes(routes.filter((it) => it.layout === "/customer"))}
                      <Route
                        path="/"
                        element={<Navigate to="/admin/default" replace />}
                      />
                    </Routes>
                  </Box>
                </>
              ) : null}
            </Box>
          </SidebarContext.Provider>
        </SupportUnreadProvider>
      </IntercomProvider>
    </Box>
  );
}
